import React, { useEffect, useState } from 'react';

/**
 * Parallax Background Component
 * Creates a multi-layer parallax effect with luxury gradients
 */
const ParallaxBackground = ({ children, overlay = true }) => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative overflow-hidden">
      {/* Layer 1: Slowest - Deep background */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          transform: `translateY(${scrollY * 0.1}px)`,
        }}
      >
        <div className="absolute top-0 -left-1/4 w-[150%] h-[200%] bg-gradient-to-br from-primary-100/30 via-transparent to-transparent dark:from-primary-900/20 blur-3xl" />
      </div>

      {/* Layer 2: Medium speed - Middle layer */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          transform: `translateY(${scrollY * 0.2}px)`,
        }}
      >
        <div className="absolute -top-1/2 right-0 w-[100%] h-[150%] bg-gradient-to-bl from-accent-100/20 via-transparent to-transparent dark:from-accent-900/10 blur-3xl" />
      </div>

      {/* Layer 3: Faster - Foreground orbs */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          transform: `translateY(${scrollY * 0.3}px)`,
        }}
      >
        <div className="absolute top-1/4 left-1/3 w-64 h-64 bg-primary-300/20 dark:bg-primary-700/10 rounded-full blur-3xl animate-float" />
        <div 
          className="absolute top-2/3 right-1/4 w-80 h-80 bg-accent-300/20 dark:bg-accent-700/10 rounded-full blur-3xl animate-float"
          style={{ animationDelay: '2s' }}
        />
      </div>

      {/* Content overlay */}
      {overlay && (
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/50 to-white dark:via-slate-900/50 dark:to-slate-900" />
      )}

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default ParallaxBackground;
